/**
 * Flattens additional_phone_numbers array into multiple users with phone_number
 * { phone_number: '012', additional_phone_numbers: ['123', '456'] } -> [{
 * phone_number: '012' }, { phone_number: '123' }, {phone_number: '456' }]
 *
 * @param users
 * @returns Users
 */
export const spreadPhoneUsers = (users) => {
    if (!(users === null || users === void 0 ? void 0 : users.length)) {
        return [];
    }
    return users.flatMap((user) => {
        var _a;
        const mappedUsers = [user];
        if ((_a = user.additional_phone_numbers) === null || _a === void 0 ? void 0 : _a.length) {
            for (const phoneNumber of user.additional_phone_numbers) {
                mappedUsers.push(Object.assign(Object.assign({}, user), { phone_number: phoneNumber, duplicate: true }));
            }
        }
        return mappedUsers;
    });
};
